export const RETURN_REQUESTS_RESET_STATE = 'RETURN_REQUESTS_RESET_STATE';
export const RETURN_REQUESTS_CURRENT_ITEM = 'RETURN_REQUESTS_CURRENT_ITEM';

export const RETURN_REQUESTS_REQUEST_LOADING = 'RETURN_REQUESTS_REQUEST_LOADING';
export const RETURN_REQUESTS_REQUEST_SUCCESS = 'RETURN_REQUESTS_REQUEST_SUCCESS';
export const RETURN_REQUESTS_REQUEST_FAILED = 'RETURN_REQUESTS_REQUEST_FAILED';

export const RETURN_REQUESTS_CURRENT_ACTION = 'RETURN_REQUESTS_CURRENT_ACTION';
export const RETURN_REQUESTS_RESET_ACTION = 'RETURN_REQUESTS_RESET_ACTION';
